<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button, RadioGroup, Radio } from "view-design";
import config from "@/../config";
import dayjs from "dayjs";
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "",
        url: {
          list: "/admin/system/meeting/sign/getMeetMore",
        },
        output: false,
      },
      menus: [
        {
          label: "签到表",
          name: "Qiandaobiao",
          auth: "system/Qiandaobiao/index",
        },
        {
          label: "出勤率",
          name: "Attendance",
          auth: "system/Attendance/index",
        },
      ],
      actions: [],
      filters: [
        {
          label: "姓名",
          KeyEnter: this.search,
          name: "signUserName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "姓名",
          minWidth: 120,
          align: "center",
          key: "signUserName",
        },
        {
          title: "被邀请（次）",
          minWidth: 150,
          align: "center",
          key: "needTimesNum",
        },
        {
          title: "实际签到",
          minWidth: 100,
          align: "center",
          key: "checkNum",
        },
        {
          title: "到会率(%)",
          minWidth: 120,
          align: "center",
          key: "checkHereRate",
        },
        {
          title: "缺勤（次）",
          minWidth: 150,
          align: "center",
          key: "absenteesNumber",
        },
      ],
    };
  },
  created() {},
  methods: {},
};
</script>

<style></style>
